// Suivi des campagnes publicitaires (Pixel Meta) et de la source des visites (UTM).
// Le pixel ne se charge que si le visiteur accepte les cookies publicitaires
// (voir components/MetaPixel.jsx). Les événements envoyés avant le chargement sont ignorés.

const UTM_KEY = "mboa_utm";
const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
const UTM_DAYS = 30;

/** Mémorise la source d'arrivée (ex. ?utm_source=facebook&utm_campaign=talent_s1), 30 jours. */
export function captureUtm() {
    try {
        const p = new URLSearchParams(window.location.search);
        const found = {};
        UTM_FIELDS.forEach((k) => { if (p.get(k)) found[k] = p.get(k).slice(0, 120); });
        if (Object.keys(found).length) localStorage.setItem(UTM_KEY, JSON.stringify({ ...found, ts: Date.now() }));
    } catch { /* stockage indisponible */ }
}

/** Source mémorisée, envoyée avec l'inscription et la candidature (ou null). */
export function getUtm() {
    try {
        const v = JSON.parse(localStorage.getItem(UTM_KEY) || "null");
        if (!v || Date.now() - (v.ts || 0) > UTM_DAYS * 86400000) return null;
        const { ts, ...rest } = v;
        return rest;
    } catch { return null; }
}

/** Événement Meta (standard : ViewContent, Lead, CompleteRegistration, SubmitApplication…). */
export function track(event, params = {}) {
    try { if (typeof window.fbq === "function") window.fbq("track", event, params); } catch { /* pixel absent */ }
}
